import React from 'react'
import PropTypes from 'prop-types'
import SvgIcon from 'Components/SvgIcon'
import {
  _ActiveMarker,
  _MarkerContent,
  _Label,
} from './styles'

const ActiveMarker = ({ lat, lng, label, onClick }) => (
  <_ActiveMarker latitude={lat} longitude={lng}>
    <_MarkerContent onClick={onClick}>
      <SvgIcon name="#icon-red-marker" width={26} height={36} />
      {label && <_Label>{label}</_Label>}
    </_MarkerContent>
  </_ActiveMarker>
)

ActiveMarker.propTypes = {
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  label: PropTypes.string,
  onClick: PropTypes.func,
}

export default React.memo(ActiveMarker)
